import axios from 'axios';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class Axioshelper {

    async getGitlabDetails(getURL) {
        let results = [];
        var response = await this.getAxios(getURL, 1);
        let totalPage = response.headers["x-total-pages"];
        results.push(...response.data)
        if (totalPage == "1") {
            return results;
        }
        for (var i = 0; i < totalPage - 1; i++) {
            response = await this.getAxios(getURL, parseInt(response.headers["x-next-page"]));
            results.push(...response.data)
        }
        return results
    }

    async getSingleGitlabDeatails(getURL) {
        var response = await this.getAxios(getURL, 1);
        return response.data;
    }

    async getAxios(url, pageNo): Promise<any> {
        let res = await axios.get(url + "&page=" + pageNo);
        return res;
    }

}